module.exports = __webpack_public_path__ + "static/media/partner-site-b-3.14e6e724.png";